import {
    createHandlerChainRunnerForOldOnComplete,
    Handler,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { getRockwellConfiguredProductsUsingConfigurationId } from "@theHescoBlueprint/Services/RockwellConfiguratorService";

export type RockwellConfiguratorRedirectPageParameter = {
    onError?: (error: string) => void;
    configurationId: string;
} & HasOnSuccess<any>;

type HandlerType = Handler<
    {
        getRockwellConfiguredProductsParameter: RockwellConfiguratorRedirectPageParameter;
        onComplete: (errorMessage: React.ReactNode) => void;
    },
    {
        apiParameter: any;
        apiResult?: any;
        result: any;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.getRockwellConfiguredProductsParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getRockwellConfiguredProductsUsingConfigurationId(
        props.parameter.getRockwellConfiguredProductsParameter.configurationId,
    );
};

export const LoadCart: HandlerType = props => {};

export const CallOnComplete: HandlerType = props => {
    props.parameter.onComplete?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, CallOnComplete];

// const getRockwellConfiguredProductsHandler = createHandlerChainRunnerForOldOnComplete(
//     chain,
//     "GetRockwellConfiguredProductsHandler",
// );

const getRockwellConfiguredProductsHandler = createHandlerChainRunnerForOldOnComplete(
    chain,
    "GetRockwellConfiguredProductsHandler",
);

export default getRockwellConfiguredProductsHandler;
